import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { ConsentsState } from '@store/consents/consents.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([ConsentsState])],
})
export class ConsentsStoreModule {}
